import { useImageSelection } from '../../../shared/selection/state/use-image-selection';
import { MAX_COMPARE_IMAGES } from '../../../shared/compareImages/state/utils';

export function useCompareSelection() {
    return useImageSelection({ maxSelected: MAX_COMPARE_IMAGES });
}
